var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedCareCoordination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.83 581.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.91,296.04c-25.13,10.91-46.66,28.57-62.29,50.68-1.78,.06-3.59,.12-5.43,.2h-101.88c-110.96-4.65-128.57,22.04-124.48,146.85v87.46H0v-150.83c0-81.09,54.29-135.5,135.27-135.5h197.85c6.79,0,13.39,.38,19.79,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.84 351.24 422.03 475.05 361.56 414.58 382.32 393.81 422.03 433.53 525.08 330.48 545.84 351.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502.11,432.5c0,.82,0,1.63-.03,2.44-.73,27.42-13.73,51.78-33.7,67.8-15.41,12.36-34.98,19.76-56.27,19.76-.82,0-1.63,0-2.44-.03-32.13-.86-60.03-18.54-75.28-44.55h0c-7.81-13.34-12.28-28.86-12.28-45.42,0-11.55,2.17-22.59,6.14-32.73,7.41-18.97,21.07-34.81,38.45-44.98,13.33-7.8,28.85-12.28,45.41-12.28v-58.72c-21.04,0-41.06,4.37-59.2,12.25-25.13,10.91-46.66,28.57-62.29,50.68-17.16,24.23-27.23,53.83-27.23,85.78,0,21.05,4.37,41.06,12.26,59.2h0c10.91,25.14,28.56,46.66,50.68,62.3,23.61,16.7,52.32,26.7,83.34,27.2,.81,.01,1.62,.02,2.44,.02,19.91,0,38.91-3.91,56.27-11.02,53.52-21.89,91.45-74.08,92.43-135.26,.01-.81,.02-1.62,.02-2.44h-58.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedCareCoordination);
export default __webpack_public_path__ + "static/media/completedCareCoordination.6cd290666019d52e6696085e15605faa.svg";
export { ForwardRef as ReactComponent };